/* eslint-disable react/no-string-refs */
import subscribeNewsletterApi from "api/contact/subscribeNewsletterApi";
import Form from "component/design-system/form/Form";
import Input from "component/design-system/form/Input";
import { isFormEnabled, Validation } from "component/formsy-components/formsy-helper";
import Alert from "component/react-bootstrap/Alert";
import Spinner from "component/spinner/spinner.component";
import VehicleSelectorForm from "component/vehicle-form/VehicleSelectorForm";
import BottomSheetWrapper from "modules/modals/BottomSheetWrapper";
import { withTranslation } from "next-i18next";
import objectAssign from "object-assign";
import { Component, createRef } from "react";
import { createVehicleDescription } from "util/vehicle/createVehicleDescription";
import { toLowerCase } from "../../util/lodash/toLowerCase";
import { validateVehicle } from "../../util/vehicle/validate-vehicle";
import styles from "./newsLetterForm.module.scss";

const defaultState = {
  loading: false,
  canSubmit: false,
  canUpdate: false,
  isSuccessUpdate: false,
  showModal: false,
  name: undefined,
  email: undefined,
  vehicle: undefined,
};

class NewsletterForm extends Component {
  constructor(props: any) {
    super(props);
    this.formRef = createRef();
    this.state = objectAssign({}, defaultState);
  }

  submit = (model) => {
    this.setState({
      loading: true,
      canSubmit: false,
    }, () => {
      const { name, email } = model;
      subscribeNewsletterApi(name, toLowerCase(email))
        .then(() => this.setState({
          name,
          email: toLowerCase(email),
          canSubmit: true,
          loading: false,
          showModal: true,
        }));
    });
  };

  handleSelectVehicle = (vehicle: any) => {
    this.setState({
      vehicle,
      canUpdate: true,
    });
  };

  handleClickUpdate() {
    const {
      vehicle,
      name,
      email,
    } = this.state;

    this.setState({
      canUpdate: false,
      loading: true,
    }, () => {
      if (validateVehicle(vehicle)) {
        subscribeNewsletterApi(name, toLowerCase(email), vehicle)
          .then(() => this.setState({
            loading: false,
            isSuccessUpdate: true,
          }));
      }
    });
  }

  handleHideModal = () => {
    const newState = { ...defaultState };
    this.setState(newState);
  };

  handleOnFormChange = () => {
    const formValidations: Validation[] = [{
      validationType: "IS_NAME",
      elementName: "name",
    }, { validationType: "IS_EMAIL", elementName: "email" }];
    const canSubmitForm = isFormEnabled(this.formRef, ["name", "email"], formValidations);
    this.setState({ canSubmit: canSubmitForm });
  };

  render() {
    const { t } = this.props;
    return (
      <div className={styles.news_letter_form}>

        <div className={styles.middle_heading}>{t("NewsletterForm.PartsAvatar_Newsletter")}</div>

        <p className={styles.middle_sub_heading}>{t("NewsletterForm.Subscribe_updates")}</p>

        <Form
          id="newsletter-form"
          className={styles.newsletter_form_comp}
          ref={this.formRef}
          onChange={this.handleOnFormChange}
          onValidSubmit={this.submit}
          fields={["name", "email"]}
        >

          <Input
            name="name"
            type="text"
            className="form-control"
            placeholder={t("NewsletterForm.First_Name")}
            required
            validations={{
              validationType: "IS_NAME",
            }}
          />

          <Input
            name="email"
            type="email"
            className="form-control"
            placeholder={t("NewsletterForm.Email")}
            validations={{
              validationType: "IS_EMAIL",
            }}
            required
          />

          <button
            id="signup-btn"
            type="submit"
            className="btn btn-primary m-t-10"
            disabled={!this.state.canSubmit}
          >

            {this.state.loading ? (
              <Spinner />
            ) : (
              t("NewsletterForm.Sign_Up")
            )}
          </button>
        </Form>
        {
          this.state.showModal && (
            <BottomSheetWrapper
              title={(
                <>
                  <i className="fa fa-rss m-r-5" />

                  <span>{t("NewsletterForm.Newsletter_Subscription")}</span>
                </>
              )}
              onHide={this.handleHideModal}
            >

              <p>{t("NewsletterForm.Wow")}</p>

              <p>{t("NewsletterForm.Brace")}</p>

              <p>{t("NewsletterForm.Weekly_showcases")}</p>

              {!this.state.isSuccessUpdate ? (
                <div>

                  <p>{t("NewsletterForm.just_newsletters")}</p>

                  <VehicleSelectorForm
                    className="default"
                    autoScroll={false}
                    onSelectVehicle={this.handleSelectVehicle}
                  />

                  <div
                    className="btn btn-primary btn-action btn-block m-t-10"
                    disabled={!this.state.canUpdate}
                    onClick={this.handleClickUpdate.bind(this)}
                  >

                    {this.state.loading ? <Spinner /> : "Update"}
                  </div>
                </div>
              ) : (
                <Alert bsStyle="success">
                  {` ${t("NewsletterForm.great_news")} ${createVehicleDescription(this.state.vehicle)} ${t("NewsletterForm.specially_for_you")}`}
                </Alert>
              )}
            </BottomSheetWrapper>
          )
        }
      </div>
    );
  }
}

export default withTranslation("common")(NewsletterForm);
